export const TIME_SCROLL_BOTTOM = 250;
export const REF_FORMS = 'refForms';
export const REF_OFFICE = 'refOffices';
export const REF_CALENDAR = 'refCalendar';
export const REF_SLOT = 'refOfficeSlot';
export const COMMERCIAL = 'commercial';
